import { Controller } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { isDefined } from 'utils/tsHelpers';
import { useHyperlinkFormContext } from '../../contexts/hyperlinkForm';
import { useTranslation } from '../../../../../../../hooks/useTranslation';

export const HrefTextInput = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useHyperlinkFormContext();

  return (
    <FormField
      labelText={t('contentPicker.textEditor.href')}
      errorText={errors.href?.message}
      hasError={isDefined(errors.href)}
      isRequired
    >
      <Controller
        name="href"
        control={control}
        rules={{ required: t('contentPicker.textEditor.missingLinkHref') }}
        render={({ field }) => (
          <InputText
            {...field}
            data-test="href-input"
            placeholder={t('contentPicker.textEditor.placeholderUrl')}
          />
        )}
      />
    </FormField>
  );
};
